import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { StudentWrapper } from './StudentCard.styled';
import {
  Center,
  FlexDivCenter,
  Text,
} from '../../components/Typography/Typography';
import UseMedia from '../../customHooks/UseMedia';
import GenerateStudentCard from '../../components/GenerateStudentCard/GenerateStudentCard';

export default () => {
  const [currentStep, setCurrentStep] = useState('id_validation');
  const [isBanMode, setIsBanMode] = useState(false);
  const { t } = useTranslation();
  const { isMobile } = UseMedia();
  const { activeUser } = useSelector((state) => state.auth);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);

  const currentStepComponentMapper = {
    id_validation: renderUploadImage,
    finished: renderFinishScreen,
  };

  function handleCaptcha(token) {
    setIsCaptchaValid(!!token);
  }

  useEffect(() => {
    if (activeUser.reserveDutyDays > 0) {
      setIsBanMode(true);
    }
  }, [activeUser]);

  function renderFinishScreen() {
    return (
      <div>
        <FlexDivCenter
          style={{
            padding: '0 20px',
            fontSize: 20,
            textAlign: 'center',
            fontWeight: 900,
            background: 'white',
            textDecoration: 'underline',
          }}
        >
          {t('save_your_student_card')}
        </FlexDivCenter>
      </div>
    );
  }

  function renderUploadImage() {
    return (
      <div
        className="animate__animated animate__fadeIn"
        style={{
          maxWidth: 400,
          background: 'white',
          padding: 35,
          borderRadius: 5,
        }}
      >
        <div>
          <Text>{t('hi_and_upload', { name: activeUser.fullname })}</Text>
        </div>
        <FlexDivCenter />
        <Center style={{ marginTop: 15 }}>
          <GenerateStudentCard
            finished={() => {
              const existing = localStorage.getItem('already_created') || 0;
              localStorage.setItem('already_created', existing + 1);
              setCurrentStep('finished');
            }}
          />
        </Center>
        <FlexDivCenter />
      </div>
    );
  }

  return (
    <StudentWrapper>
      <FlexDivCenter>
        {isBanMode && currentStep !== 'finished' ? (
          <div style={{ background: 'white', padding: 35, borderRadius: 5 }}>
            {t('user_locked_for_student_card')}
          </div>
        ) : (
          currentStepComponentMapper[currentStep]()
        )}
      </FlexDivCenter>
    </StudentWrapper>
  );
};
